import React from 'react'
import { useWallet } from '@web/walter-lib/stream/hooks/wallet/useWallet'
import { Loader } from '@web/walter-ui-kit'

import cn from 'classnames'
import styles from './style.module.css'
import localStyles from './Preloader.module.css'
import WalletOverviewPreloader from './WalletOverview/Preloader'
import AssetsListPreloader from '~pages/WalletPage/AssetsList/Preloader'
import { useCurrencies, useProviders, useSwapCurrencies, useSwapFeatures } from '~api'
import PageHeader from '~components/PageLayout/PageHeader'
import PageLayout from '~components/PageLayout'
import MultiWidgetPreloader from '~components/MultiWidget/Preloader'

function Preloader() {
    useCurrencies()
    useSwapCurrencies()
    useSwapFeatures()
    useProviders()
    useWallet()

    return (
        <PageLayout
            contentWidth="xl"
            header={
                <PageHeader
                    rootPage
                    title={
                        <div className={localStyles.wrap}>
                            <Loader width={160} height={20} />
                        </div>
                    }
                />
            }
        >
            <div className={cn(styles.wrap, localStyles.preloaderWrap)} data-pointer="wallet_page_preloader">
                <div className={styles.leftColumn}>
                    <div className={styles.mainBlock}>
                        <WalletOverviewPreloader />
                        <AssetsListPreloader />
                    </div>
                </div>
                <div className={styles.dividerColumn} />
                <div className={styles.rightColumn}>
                    <div className={styles.rightColumnContent}>
                        <MultiWidgetPreloader />
                    </div>
                </div>
            </div>
        </PageLayout>
    )
}

export default Preloader
